import React from 'react';
import FadeLoader from 'react-spinners/FadeLoader';
import styles from './BatchDownloadForm.module.scss';

const Spinner = () => (
  <div className={styles.spinnerContainer}>
    <div className={styles.scaled}>
      <FadeLoader
        height={16}
        width={7}
      />
    </div>
  </div>
);

export default Spinner;
